// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryForm_root__1BOSY","icon":"EnquiryForm_icon__2KRX-","heading":"EnquiryForm_heading__1ub4-","field":"EnquiryForm_field__mwL1k","error":"EnquiryForm_error__2EBa9"};